interface HeaderProps {
  scrolled: boolean;
}

export default function Header({ scrolled }: HeaderProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a1628]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://static.readdy.ai/image/f493cbe5c2084134677121347fdba237/214be233785e39ebb6795040f74f7c21.png" 
              alt="Windie's Mania SHABADABA Logo" 
              className="w-12 h-12 object-contain"
            />
            <h1 className="text-xl md:text-2xl font-bold text-[#ff1493] whitespace-nowrap">
              Windie's Mania SHABADABA
            </h1>
          </div>
          
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-[#ff1493] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              番組について
            </button>
            <button
              onClick={() => scrollToSection('programs')}
              className="text-white hover:text-[#ff1493] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              放送中の番組
            </button>
            <button
              onClick={() => scrollToSection('listen')}
              className="text-white hover:text-[#ff1493] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              聴き方
            </button>
            <button
              onClick={() => scrollToSection('social')}
              className="text-white hover:text-[#ff1493] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              SNS
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#ff1493] text-white px-6 py-2 rounded-full hover:bg-[#ff69b4] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </button>
          </nav>

          <button
            className="md:hidden text-white text-2xl cursor-pointer"
            onClick={() => {
              const nav = document.getElementById('mobile-nav');
              if (nav) {
                nav.classList.toggle('hidden');
              }
            }}
          >
            <i className="ri-menu-line"></i>
          </button>
        </div>

        <div id="mobile-nav" className="hidden md:hidden mt-4 pb-4">
          <nav className="flex flex-col gap-4">
            <button
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-[#ff1493] transition-colors duration-300 text-left whitespace-nowrap cursor-pointer"
            >
              番組について
            </button>
            <button
              onClick={() => scrollToSection('programs')}
              className="text-white hover:text-[#ff1493] transition-colors duration-300 text-left whitespace-nowrap cursor-pointer"
            >
              放送中の番組
            </button>
            <button
              onClick={() => scrollToSection('listen')}
              className="text-white hover:text-[#ff1493] transition-colors duration-300 text-left whitespace-nowrap cursor-pointer"
            >
              聴き方
            </button>
            <button
              onClick={() => scrollToSection('social')}
              className="text-white hover:text-[#ff1493] transition-colors duration-300 text-left whitespace-nowrap cursor-pointer"
            >
              SNS
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#ff1493] text-white px-6 py-2 rounded-full hover:bg-[#ff69b4] transition-all duration-300 text-left whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
}
